<input
  #csvUploaderInput
  type="file"
  accept=".csv"
  [ngStyle]="{ display: 'none' }"
  (change)="onAfterAddingFile($event)"
/>
<button
  mat-raised-button
  color="primary"
  [disabled]="disabled"
  (click)="openFileInput()"
>
  <span *ngIf="buttonText">{{ buttonText }}</span>
  <span *ngIf="!buttonText" i18n="@@global.uploadACsv">Upload a CSV</span>
  <i *ngIf="disabled" nz-icon nzType="sync" nzSpin class="u-marginLeft-8"></i>
</button>
